var _defineProperty = require("/Users/sharpga/personal/directory/node_modules/@babel/runtime/helpers/defineProperty");

var _provider;

var provider = (_provider = {
  provinces: ["Ontario", "Quebec", "Nova Scotia", "New Brunswich", "Manitoba", "British Columbia", "Prince Edward Island", "Saskatchewan", "Alberta", "Newfoundland and Labrador", "Northwest Territories", "Yukon", "Nunavut"],
  province_abbr: ["ON", "QC", "NS", "NB", "MB", "BC", "PE", "SK", "AB", "NL", "NT", "YT", "NU"],
  postal_code_format: ["X#X-#X#", 'X#X#X#', 'X#X #X#'],
  capital_cities: ["Toronto", "Quebec City", "Halifax", "Fredericton", "Winnipeg", "Victoria", "Charlottetown", "Regina", "Edmonton", "St. John's", "Yellowknife", "Whitehorse", "Iqaluit"],
  province: function province() {
    return this.random_element(this.provinces);
  }
}, _defineProperty(_provider, "province_abbr", function province_abbr() {
  return this.random_element(this.province_abbr);
}), _defineProperty(_provider, "postal_code", function postal_code() {
  return this.numerify(this.letterify(this.random_element(this.postal_code_format))).toUpperCase();
}), _defineProperty(_provider, "capital_city", function capital_city(prov) {
  if (prov) {
    var idx = this.provinces.indexOf(prov);
    if (idx === -1) throw new Error('province not found');
    return this.capital_cities[idx];
  }

  return this.random_element(this.capital_cities);
}), _provider);
module.exports = provider;